/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/userLists.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_SECTION } from "../graphql";
import { VApplication } from "../../../application";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISectionMethods extends IPluginMethodMap {
  getSectionProps(args: any): Promise<any>;
}

export class SectionService implements IAgentPlugin {
  readonly methods: ISectionMethods;

  constructor() {
    this.methods = {
      getSectionProps: this.getSectionProps.bind(this),
    };
  }

  async getSectionProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const filter = args.id
      ? {
          _id: {
            eq: args.id,
          },
        }
      : {};

    try {
      if (client) {
        const res = await client.query({
          query: GET_SECTION,
          variables: {
            filter: filter,
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          return {
            sectionDropDown: this.transformArray(
              res?.data?.getCostumeTypes?.content
            ),
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      let _display_message =
      err?.graphQLErrors &&
      Array.isArray(err?.graphQLErrors) &&
      err?.graphQLErrors.find((item: any) => item.extensions);
    if (_display_message?.extensions?.display_message) {
      throw Error(_display_message?.extensions?.display_message);
    }

    throw err;
    }
  }

  private transformArray(array: any) {
    return array
      .map((item) => {
        const label = item.name;
        if (!label) {
          return null; // Ignore the item if both fullName and email are empty
        }
        return {
          id: item.name,
          label: label,
        };
      })
      .filter(Boolean); // Filter out any null values from the array
  }
}
